import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import {
  CreateCustomerClubDeviceCommand,
  SmsSentPeriodType,
  UpdateCustomerClubDeviceCommand,
} from 'src/app/core/api/models';
import { CustomerClubDevicesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { CommonModule } from '@angular/common';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';
import { CustomerClubDevicesDetailComponent } from "./customer-club-devices-detail/customer-club-devices-detail.component";

@Component({
    selector: 'app-customer-club-devices-form',
    templateUrl: './customer-club-devices-form.component.html',
    styleUrls: ['./customer-club-devices-form.component.scss'],
    imports: [SmsBodyModule,
        BaseFormModule,
        CustomerClubDevicesDetailComponent
    ]
})
export class CustomerClubDevicesFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  @Input('organizationId') input_organizationId;
  @Input('userId') input_userId;

  model: CreateCustomerClubDeviceCommand = {};
  formPageConfig: FormPageConfig<any> = {};
  isShowDetail: boolean = false;
  customerClubDevicesDetailForms: FormGroup[] = [];

  //#endregion

  constructor(protected currentService: CustomerClubDevicesService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  initModel() {
    try {
      this.model.details = [];
      super.initModel();
      if (
        !this.formPageConfig.isEditMode ||
        (this.formPageConfig.isEditMode && this.model.details.length == 0)
      ) {
        this.isShowDetail = true;
        this.onChangeIsShowDetail();
      }

      if (this.formPageConfig.isEditMode && this.model.details.length > 0)
        this.isShowDetail = true;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      webhookUrl: new FormControl(''),
      isShowDetail: new FormControl(''),
      deviceId: new FormControl('', Validators.required),
    });
  }

  //#region detail

  onAddDetail() {
    try {
      this.model.details.push({
        delayType: SmsSentPeriodType.Minute,
        delayValue: 0,
        isActive: false,
        dynamicTemplateId: null,
        privateNumberId: null,
        smsText: '',
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onRemoveDetail(index: number) {
    try {
      this.model.details.splice(index, 1);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onChangeIsShowDetail() {
    if (this.isShowDetail) {
      this.model.details = [];
      this.onAddDetail();
    }
  }

  //#endregion

  //#region api

  baseCreateApi(model: CreateCustomerClubDeviceCommand) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .customerClubDevicesCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  baseUpdateApi(model: UpdateCustomerClubDeviceCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .customerClubDevicesUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (this.loading) return;

      if (!this.isValidForm(this.form, this.tagName)) return;

      if (!this.isShowDetail) this.model.details = null;
      else if (!this.isValidCustomerClubDevicesDetailForms()) return;

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  isValidCustomerClubDevicesDetailForms(): boolean {
    try {
      let result: boolean = true;
      this.customerClubDevicesDetailForms.forEach((form) => {
        if (form.invalid) {
          result = false;
          form.markAllAsTouched();
        }
      });

      return result;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onRefresh() {
    this.model = {};
    this.initModel();
  }
}
